
  import { ldJSON } from '@/scripts/article';

  export default {
    props: { article: { type: Object, required: true } },
    head () {
      return {
        script: [
          {
            defer: true,
            innerHTML: ldJSON(this.article, this.$dateTime, this.$railsHost()),
            type: 'application/ld+json'
          }
        ]
      };
    },
    computed: {
      categoryDescription () {
        if (this.article.type === 'article') {
          return this.article.category_description;
        } else if (this.article.type === 'guide') {
          return this.$t('guideCategory', [this.article.category_description]);
        }
        return '';
      }
    }
  };
